import type { Technique } from '../types';
import { EXTRUDE_3D_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type Extrude3dState } from './render';

export const extrude3d: Technique<Extrude3dState> = {
  id: 'extrude-3d',
  name: '3D-Extrusion',
  category: 'dimension',
  description: 'Extrudiert die echten Buchstabenkonturen in den Raum, mit Material, Licht und Schatten.',
  params: EXTRUDE_3D_PARAMS,
  renderer: 'webgl',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
